export enum FileTypeEnum {
  jpg = "jpg",
  jpeg = "jpeg",
  png = "png",
  xls = "xls",
  xlsx = "xlsx",
  doc = "doc",
  docx = "docx",
  pdf = "pdf",
  mp4 = "mp4",
  mov = "mov",
  wmv = "wmv",
  avi = "avi",
  flv = "flv",
  mpeg2 = "mpeg-2",
}
